/* GET NAILS - Despre noi 08: carusel comunitate, compatibil cu Shopify Customize. */
(function () {
  'use strict';

  if (window.__gnAboutPeopleBound) return;
  window.__gnAboutPeopleBound = true;

  var rootSelector = '[data-gn-about-people]';
  var slideSelector = '[data-gn-people-slide]';
  var thumbSelector = '[data-gn-people-thumb]';
  var dotSelector = '[data-gn-people-dot]';
  var captionSelector = '[data-gn-people-caption]';

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function currentIndex(root) {
    var thumbs = all(root, thumbSelector);
    var index = thumbs.findIndex(function (thumb) {
      return thumb.getAttribute('aria-current') === 'true';
    });
    return Math.max(0, index);
  }

  function show(root, requestedIndex) {
    var slides = all(root, slideSelector);
    if (!slides.length || !Number.isFinite(requestedIndex)) return;
    var index = ((requestedIndex % slides.length) + slides.length) % slides.length;

    slides.forEach(function (slide, i) {
      slide.hidden = i !== index;
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    all(root, thumbSelector).forEach(function (button, i) {
      button.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
    all(root, dotSelector).forEach(function (button, i) {
      button.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });
    all(root, captionSelector).forEach(function (button, i) {
      button.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    var counter = root.querySelector('[data-gn-people-counter]');
    if (counter) counter.textContent = String(index + 1).padStart(2, '0');
    var status = root.querySelector('[data-gn-people-status]');
    if (status) status.textContent = 'Fotografia ' + (index + 1) + ' din ' + slides.length;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('[data-gn-people-prev], [data-gn-people-next], [data-gn-people-thumb], [data-gn-people-dot], [data-gn-people-caption]');
    if (!button) return;
    var root = button.closest(rootSelector);
    if (!root) return;

    var next = currentIndex(root);
    if (button.hasAttribute('data-gn-people-prev')) {
      next -= 1;
    } else if (button.hasAttribute('data-gn-people-next')) {
      next += 1;
    } else {
      next = Number.parseInt(button.getAttribute('data-gn-people-index'), 10);
    }
    show(root, next);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var target = event.target;
    if (!target || !target.closest) return;
    var active = target.closest(thumbSelector + ', ' + dotSelector + ', ' + captionSelector);
    if (!active) return;
    var root = active.closest(rootSelector);
    if (!root) return;
    var buttons = active.matches(thumbSelector)
      ? all(root, thumbSelector)
      : (active.matches(dotSelector) ? all(root, dotSelector) : all(root, captionSelector));
    if (buttons.length < 2) return;
    var index = buttons.indexOf(active);
    if (index < 0) return;
    event.preventDefault();
    index = (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
    show(root, index);
    buttons[index].focus();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var thumb = target.matches && target.matches(thumbSelector) ? target : target.querySelector(thumbSelector);
    if (!thumb) return;
    var root = thumb.closest(rootSelector);
    if (root) show(root, Number.parseInt(thumb.getAttribute('data-gn-people-index'), 10));
  });
}());
